
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "539f262b4a0936da56d00d34460a1276bc81d31c",
  "nuxt": {
    "buildId": "c0b39353-e0ce-48c3-b6e5-26c289bfc35c"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
